import { render, staticRenderFns } from "./ClassEmotionRank.vue?vue&type=template&id=08ae50da&scoped=true"
import script from "./ClassEmotionRank.vue?vue&type=script&lang=js"
export * from "./ClassEmotionRank.vue?vue&type=script&lang=js"
import style0 from "./ClassEmotionRank.vue?vue&type=style&index=0&id=08ae50da&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae50da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ae50da')) {
      api.createRecord('08ae50da', component.options)
    } else {
      api.reload('08ae50da', component.options)
    }
    module.hot.accept("./ClassEmotionRank.vue?vue&type=template&id=08ae50da&scoped=true", function () {
      api.rerender('08ae50da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PsychologicalMonthReport/components/SentimentAnalysis/components/ClassEmotionRank.vue"
export default component.exports